import { render } from "./projectCom.vue?vue&type=template&id=666e4d32&scoped=true"
import script from "./projectCom.vue?vue&type=script&lang=js"
export * from "./projectCom.vue?vue&type=script&lang=js"

import "./projectCom.vue?vue&type=style&index=0&id=666e4d32&lang=less&scoped=true"

import exportComponent from "D:\\Jhy\\点甜官网\\2026最新版官网\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666e4d32"]])

export default __exports__